import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { useAppState } from '../contexts/AppStateContext';
import ToolCategory from './ToolCategory';

const ToolSelector = () => {
  const { t } = useLanguage();
  const { state, dispatch } = useAppState();

  const toolCategories = [
    {
      title: t('pdfTools'),
      tools: [
        { id: 'pdf-to-image', title: t('pdfToImage'), description: t('pdfToImageDesc'), icon: '🖼️', color: 'bg-pink-100' },
        { id: 'pdf-compress', title: t('pdfCompress'), description: t('pdfCompressDesc'), icon: '📉', color: 'bg-orange-100' },
      ],
    },
    {
      title: t('imageTools'),
      tools: [
        { id: 'image-convert', title: t('imageConvert'), description: t('imageConvertDesc'), icon: '🔄', color: 'bg-green-100' },
        { id: 'image-resize', title: t('imageResize'), description: t('imageResizeDesc'), icon: '⤡', color: 'bg-blue-100' },
        { id: 'image-compress', title: t('imageCompress'), description: t('imageCompressDesc'), icon: '↔', color: 'bg-purple-100' },
      ],
    },
  ];

  const selectTool = (toolId) => {
    dispatch({ type: 'SET_CURRENT_TOOL', payload: toolId });
    dispatch({ type: 'RESET_TOOL' });
    // 更新 hash URL 以便 SEO 追蹤
    window.history.replaceState(null, '', `#/tool/${toolId}`);
  };

  return (
    <motion.div
      className="bg-white rounded-lg shadow-sm border border-gray-200"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.3 }}
    >
      <div className="p-4 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-800">{t('selectFunction')}</h3>
      </div>
      <div className="max-h-96 overflow-y-auto">
        {toolCategories.map((category, index) => (
          <ToolCategory
            key={index}
            category={category}
            currentTool={state.currentTool}
            onSelectTool={selectTool}
          />
        ))}
      </div>
    </motion.div>
  );
};

export default ToolSelector;